import dayjs from "dayjs";

export enum EnumNetworkOwnership {
  InternalManaged,
  ExternalSelfManaged,
  Undefined,
}

export interface IPage {
  title: string;
  key: string;
  url: string;
}

export interface ICustomerSearchParams {
  customerId?: string;
  name?: string;
  networkOwnership: string;
}

export enum EnumDeviceSearchType {
  customerName = 'Customer Name',
  customerId = 'Customer ID',
  deviceIdSerial = 'Device ID or Serial',
  networkId = 'Device Network ID',
}

export interface IDeviceSearchParams {
  searchType: EnumDeviceSearchType;
  keywords?: string;
}

export interface IEventSearchParams {
  searchType: EnumDeviceSearchType;
  keywords?: string;
  timeRange?: [dayjs.Dayjs, dayjs.Dayjs];
  startTime?: string;
  endTime?: string;
}

export interface ICoordinate {
  lat: number;
  lng: number;
}

export type DeviceType = 'LevelSense' | 'PeopleSense' | 'DigiSense' | 'GeoSense';